import { render, staticRenderFns } from "./couponList.vue?vue&type=template&id=7724bdce&scoped=true&"
import script from "./couponList.vue?vue&type=script&lang=ts&"
export * from "./couponList.vue?vue&type=script&lang=ts&"
import style0 from "./couponList.vue?vue&type=style&index=0&id=7724bdce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7724bdce",
  null
  
)

export default component.exports